import { initializeApp } from "firebase/app";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";
import keys from "./keys";

const isDev = window.location.hostname.includes("dev.") || window.location.hostname === "localhost";
const firebaseConfig = isDev ? keys.firebase.dev : keys.firebase.prod;
const firebaseApp = initializeApp(firebaseConfig);
console.log(firebaseApp.options.projectId);

// Connect to Functions emulator when running locally
if (isDev && window.location.hostname === "localhost") {
    const functions = getFunctions(firebaseApp);
    connectFunctionsEmulator(functions, "127.0.0.1", 3001);
    console.log("[Config] Connected to Functions emulator at 127.0.0.1:3001");
}

// domain
const domain = "toonkids.com";
const domainUrl = "https://"+domain;

// storage
const bucketName = "storage"+"."+domain;
const storageDomain = 'https://'+bucketName;

//export
const Config = {
    domain: domainUrl,
    storageDomain: storageDomain
}
export default Config;
